// extracted by mini-css-extract-plugin
export var borderTop = "_n-3";
export var linkIcon = "_n-5";
export var linkIconSm = "_n-6";
export var linkOutCard = "_n-7 _n-4";
export var linkRow = "_n-2";
export var pageContainer = "_n-1";
export var providerIcon = "_n-8";
export var roundedBorder = "_n-4";
export var settingsContent = "_n-0";